import React from "react"
import { useLocation, useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button, } from "components"
import classes from "./CheckoutTableNumber.module.scss"

const CheckoutTableNumber = props => {
  const {
    disabled,
    note,
    discounts,
    cashTypes,
    isLinkPay,
    multiplePayment,
    focusedCashType,
    printCustomerReceipt,
    selectedUserAccount,
    sendPrintCustomerReceiptToPos
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const location = useLocation()

  const tableNumber =
    useSelector(state => state.order.tableNumber)

  const handleClick = () => {
    history.push(
      "/kitchen-tables",
      {
        previousPage: "/checkout",
        mode: location.state?.mode,
        previousChechkoutStates
      }
    )
  }

  const previousChechkoutStates = {
    note,
    discounts,
    cashTypes,
    isLinkPay,
    focusedCashType,
    printCustomerReceipt,
    sendPrintCustomerReceiptToPos,
    selectedUserAccount,
    multiplePayment
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("شماره_میز")}:
      </span>

      <Button
        className={classes["button"]}
        disabled={disabled}
        onClick={handleClick}
      >
        {!!tableNumber ? tableNumber : t("انتخاب")}
      </Button>
    </div>
  )
}

export default CheckoutTableNumber